import colors from './styles/colors';
import halos from './styles/halos';
import mediaQuery from './styles/mediaQuery';
import shadows from './styles/shadows';
import transitions from './styles/transitions';
import typography from './styles/typography';
import zIndex from './styles/zIndex';
export { default as Reset } from './Reset';
export { default as AlloyScopedGlobals } from './AlloyScopedGlobals';
export { getInteractiveStyles } from './styles/helpers';
export default {
  name: 'Light',
  colors: colors,
  typography: typography,
  transitions: transitions,
  halos: halos,
  zIndex: zIndex,
  shadows: shadows,
  mediaQuery: mediaQuery
};
//# sourceMappingURL=index.js.map